import { GetterTree } from "vuex";
import { IReceptionState } from "./state";
import { IReceptionDay, IReception, IAskAppointment, IReceptionNotification } from "@/models";

export const getters: GetterTree<IReceptionState, any> = {
    getReceptionDay: (state) => (): IReceptionDay => {
        return state.receptionDay;
    },

    getNotifications: (state) => (): IReceptionNotification[] => {
        return state.notifications;
    },

    getNotificationById: (state) => (id: number): IReceptionNotification => {
        return state.notifications.find(x => x.askAppointment.askAppointmentId === id);
    },

    getSelectedNotification: (state) => (): IReceptionNotification => {
        return state.selectedNotification;
    },

    getSelectedReception: (state) => (): IReception => {
        return state.selectedReception;
    },

    getValidationPictures: (state) => (): string[] => {
        return state.validationPictures;
    },
};
